import { axiosRequest } from '../../utils/Requests.js';

export default {
    props: [ 'imobiliaria' ],
    data() {
      return {
        mensagem: {
          cliente: "",
          telefone: "",
          email: "",
          texto: ""
        },
        showToast: false,
        toastTitle: "",
        toastVariant: "",
        toastMessage: "",
      }
    },
    computed: {
      isVisibleMapa() {
        return this.imobiliaria.urlMapaEstatico !== null;
      },
      nomeImobiliaria() { return this.imobiliaria.nome },
    },
    mounted() {
      document.title = "Anuncie Aqui | " + this.imobiliaria.nome
    },
    methods: {
      enviarMensagem() {
        axiosRequest.post("/enviarMensagem", this.mensagem)
        .then((resultado) => {
          this.mensagem.cliente = "";
          this.mensagem.telefone = "";
          this.mensagem.email = "";
          this.mensagem.texto = "";
          this.setData(resultado.data)
        }).catch(() => {
          this.pagina += 1
          this.loadingImoveis = false;
          this.showToast = true;
          this.toastTitle = "Sucesso";
          this.toastVariant = "success";
          this.toastMessage = "Sua mensagem foi enviada com sucesso";
        });
      }
    }
}
